/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import '../../../styles/moreShapes.scss';

export class MoreShapes extends Component {
  render() {
    return (
      <div className="moreShapes">
        <div> More </div>
        <div>Shapes</div>
      </div>
    );
  }
}
